import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { LegacyDealImportModal, LegacyLoanAllocationModal, LegacyPackageImportModal } from '@/Components/Modals';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegacyImportBadge',
  props: {
    documentUrl: { type: String, required: true },
    dataImportUrl: { type: String, required: true },
    legacyUrl: { type: String, required: true },
    verificationToken: { type: String, required: true }
  },
  setup(__props: any) {



const showPackageModal = ref(false);
const showDealModal = ref(false);
const showLoanAllocationModal = ref(false);
const showPopover = ref(false);
const wrapper = ref<HTMLElement | null>(null);

onMounted(async () => {
  setTimeout(() => wrapper.value?.classList.remove('hidden'), 500);
});

return { __sfc: true,showPackageModal, showDealModal, showLoanAllocationModal, showPopover, wrapper, LegacyDealImportModal, LegacyLoanAllocationModal, LegacyPackageImportModal }
}

})